import React, { Component } from "react";
import { Link } from "react-router-dom";
import settings from "../settings";

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  zoom,
} from "chart.js";
import zoomPlugin from "chartjs-plugin-zoom";
import { Bar } from "react-chartjs-2";

import Scrollbars from "react-custom-scrollbars";

class Chart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      data: [],
    };
    this.chartRef = React.createRef();
  }

  componentDidMount() {
    this.loadData();
  }

  loadData() {
    this.setState({ isLoading: true });
    fetch(
      settings.server_url +
        "get_packing_balance/" +
        window.sessionStorage.getItem("sid")
    )
      .then((res) => res.json())
      .then((response) => {
        if (response.result) {
          const formattedData = response.data.map((item) => ({
            packing_code: item.packing_code,
            balance: item.balance,
          }));

          this.setState({
            data: formattedData,
            isLoading: false,
          });
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        this.setState({ isLoading: false });
      });
  }

  handleZoomIn = () => {
    const chart = this.chartRef.current;
    if (chart) {
      chart.zoom(1.1); // 10% zoom in
    }
  };

  handleZoomOut = () => {
    const chart = this.chartRef.current;
    if (chart) {
      chart.zoom(0.9); // 10% zoom out
    }
  };

  handlePanLeft = () => {
    const chart = this.chartRef.current;
    if (chart) {
      chart.pan({ x: 50 }); // Pan 50 pixels naar links
    }
  };

  handlePanRight = () => {
    const chart = this.chartRef.current;
    if (chart) {
      chart.pan({ x: -50 }); // Pan 50 pixels naar rechts
    }
  };

  render() {
    ChartJS.register(
      CategoryScale,
      LinearScale,
      BarElement,
      Title,
      Tooltip,
      Legend,
      zoomPlugin
    );

    const options = {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          position: "top",
        },
        zoom: {
          zoom: {
            wheel: {
              enabled: true,
            },
            pinch: {
              enabled: true,
            },
            mode: "x",
          },
          pan: {
            enabled: true,
            mode: "x",
          },
        },
      },
    };

    const labels = this.state.data
      ? this.state.data.map((item) => item.packing_code)
      : [];

    const data = {
      labels,
      datasets: [
        {
          label: "Saldo",
          data: this.state.data
            ? this.state.data.map((item) => parseInt(item.balance))
            : [],
          backgroundColor: this.state.data
            ? this.state.data.map(
                (item) =>
                  parseInt(item.balance) >= 0
                    ? "rgba(75, 192, 75, 0.5)" // groen voor positief
                    : "rgba(255, 99, 132, 0.5)" // rood voor negatief
              )
            : [],
        },
      ],
    };

    return (
      <div className="gridItem">
        <div className="gridHeader">
          <div className="gridHeaderTitle">Emballage Saldo</div>
          <div className="gridHeaderAll">
            <Link
              to={{ pathname: "/orders", state: { activeTab: "4" } }}
              className="">
              Bekijk alles
            </Link>
          </div>
        </div>
        {this.state.isLoading ? (
          <Scrollbars style={{ height: 272 }}>
            <div className="gridRows loading"></div>
          </Scrollbars>
        ) : (
          <Scrollbars style={{ height: 272 }} autoHide universal>
            <div
              className="gridRows"
              style={{ height: "calc(100% - 30px)", padding: "5px" }}>
              <Bar
                ref={this.chartRef}
                options={options}
                data={data}
                style={{ height: "100%" }}
              />
            </div>
            <i
              onClick={this.handlePanLeft}
              className="fas fa-arrow-left"
              role="button"
              aria-label="Pan left"
              style={{ cursor: "pointer", padding: "0 5px" }}></i>
            <i
              onClick={this.handlePanRight}
              className="fas fa-arrow-right"
              role="button"
              aria-label="Pan right"
              style={{ cursor: "pointer", padding: "0 5px" }}></i>
            <i
              onClick={this.handleZoomOut}
              className="fas fa-minus"
              role="button"
              aria-label="Zoom out"
              style={{ cursor: "pointer", padding: "0 5px" }}></i>
            <i
              onClick={this.handleZoomIn}
              className="fas fa-plus"
              role="button"
              aria-label="Zoom in"
              style={{ cursor: "pointer", padding: "0 5px" }}></i>
          </Scrollbars>
        )}
      </div>
    );
  }
}

export default Chart;
